import { ReactNode } from "react";
import { cn } from "@/lib/utils";
import { Check, AlertTriangle, Info } from "lucide-react";

export enum StatusType {
  SUCCESS = "success",
  ERROR = "error",
  INFO = "info",
  WARNING = "warning"
}

const STATUS_CONFIG = {
  [StatusType.SUCCESS]: {
    iconBg: "bg-green-100",
    iconColor: "text-green-600",
    defaultIcon: Check,
  },
  [StatusType.ERROR]: {
    iconBg: "bg-red-100",
    iconColor: "text-red-600",
    defaultIcon: AlertTriangle,
  },
  [StatusType.WARNING]: {
    iconBg: "bg-orange-100",
    iconColor: "text-orange-600",
    defaultIcon: AlertTriangle,
  },
  [StatusType.INFO]: {
    iconBg: "bg-blue-100",
    iconColor: "text-blue-600",
    defaultIcon: Info,
  },
};

interface StatusHeaderProps {
  type: StatusType;
  title: string;
  icon?: ReactNode;
  className?: string;
}

export function StatusHeader({
  type = StatusType.SUCCESS,
  title,
  icon,
  className,
}: StatusHeaderProps) {
  const { iconBg, iconColor, defaultIcon: DefaultIcon } = STATUS_CONFIG[type] || STATUS_CONFIG[StatusType.INFO];

  return (
    <div className={cn("flex flex-col items-center space-y-4", className)}>
      <div className={cn("flex items-center justify-center w-16 h-16 rounded-full", iconBg)}>
        {icon || <DefaultIcon className={cn("w-8 h-8", iconColor)} />}
      </div>
      <h2 className="text-2xl font-bold text-center">{title}</h2>
    </div>
  );
} 